import { Sidebar } from "@kazaar-platform/design-system";
import { clsx } from "clsx";
import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";
import KazaarTextLogo from "@/assets/logos/kazaar_logo.svg";
import { Header } from "@/components/Header";
import { ModalSetupUserInfo } from "@/modals/ModalSetupUserInfo/ModalSetupUserInfo";
import { userAtom } from "@/store";
import { type LayoutProps, type SideBarItem } from "./Layout.types";

export const Layout = ({ sideBarItems, className, children }: LayoutProps) => {
  const location = useLocation();
  const currentUser = useAtomValue(userAtom);

  const isOpenSetupUserModal =
    currentUser?.id && (!currentUser.firstName || !currentUser.lastName);

  const renderSidebarItem = (item: SideBarItem) => {
    if (!item.href) {
      return null;
    }

    const isActive = location.pathname.includes(item.href);
    const queryParams = isActive ? location.search : "";

    const itemProps = {
      ...item,
      href: item.href,
      queryParams,
      active: isActive,
    };

    return (
      <Sidebar.Item key={item.href} {...itemProps}>
        {item.name}
      </Sidebar.Item>
    );
  };

  return (
    <div className={clsx("h-screen w-screen overflow-hidden", className)}>
      <Header logo={KazaarTextLogo} />

      {isOpenSetupUserModal && <ModalSetupUserInfo />}

      <div className="flex">
        <Sidebar>
          <div className="flex w-full flex-col items-center gap-sp-md">
            <div className="flex w-full flex-col">
              {sideBarItems.map(renderSidebarItem)}
            </div>
          </div>
        </Sidebar>

        <div
          className={clsx(
            "relative h-[calc(100vh-100px)] w-full overflow-hidden bg-slate-50 sm:h-[calc(100vh-60px)] "
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
